import { v4 } from 'uuid';

export const convertHeicToJpg = async (blob: File): Promise<File> => {
  if (blob.name.toLowerCase().endsWith('.heic')) {
    // heic2any is massive. We do NOT want this code in the main bundle
    const heic2any = await import('heic2any');
    const output = await heic2any.default({ blob, toType: 'image/jpeg' });
    const outBlob = Array.isArray(output) ? output : [output];
    return new File(outBlob, blob.name.replace(/heic/i, 'jpg'));
  }

  return blob;
};

export const convertFileNameUuid = async (blob: File): Promise<File> => {
  const ext = blob.name.split('.').pop();
  return new File([blob], `${v4()}.${ext}`);
};

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340682324189
 */
export const processImage = async (blob: File): Promise<File> => {
  const renamedBlob = await convertFileNameUuid(blob);
  const convertedBlob = await convertHeicToJpg(renamedBlob);
  return convertedBlob;
};
